import { SET_USER_INFOS } from '../actions/types';

const initialState = {
	infos: {}
};

export default (state = initialState, action = {}) => {
	switch (action.type) {
		case SET_USER_INFOS:
			state.infos[action.userId] = action.userInfo
			return {
				infos: state.infos
			};
		default: return state;
	}
}